export default function EpmtyAgenda() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "60px 20px",
        color: "#9e9e9e",
        backgroundColor: "#fbfbfb",
        borderRadius: "8px",
        border: "1px dashed #e0e0e0",
        marginTop: "20px",
      }}>
      <span style={{ fontSize: "40px", marginBottom: "10px" }}>📅</span>
      <h5 style={{ margin: 0, fontWeight: "600" }}>Занятий не запланировано</h5>
      <p style={{ margin: "5px 0 0 0", fontSize: "14px" }}>
        На выбранный период времени график пуст
      </p>
    </div>
  );
}
